import React, { useEffect, useState } from 'react'
import styled from 'styled-components';


const CheckBoxDiv = styled.div`
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border:1px solid #2196F3;
  border-radius:3px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.container input:checked ~ .checkmark:after {
  border: solid #2196F3;
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

`;

interface CheckBoxProps {
  id: string,
  name?: string,
  label?: string,
  isChecked: boolean,
  styles?: any,
  handleChange?: (e: any) => void,
  fontSize?: number,
  disabled?: boolean
}

export default function CheckBox(props: CheckBoxProps) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(props.isChecked)
  }, [props.isChecked])

  const handleCheckBox = (e: any) => {
    setChecked(checked => !checked);
    props.handleChange && props.handleChange(!checked)
  }

  return (
    <CheckBoxDiv style={props.styles}>
      <label className="container" style={{ fontSize: props.fontSize }}>{props.label}
        <input name={props.name} id={props.id} disabled={props.disabled} data-testid={`test-${props.id}`} type="checkbox" checked={checked} onChange={handleCheckBox} />
        <span className="checkmark"></span>
      </label>
    </CheckBoxDiv>
  )
}
